import { render, staticRenderFns } from "./featured-book-stats.vue?vue&type=template&id=56585d98&"
import script from "./featured-book-stats.vue?vue&type=script&lang=js&"
export * from "./featured-book-stats.vue?vue&type=script&lang=js&"
import style0 from "./featured-book-stats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports